import { memo } from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import FilterSlideoutSection from '../FilterSlideoutSection.jsx';
import FilterSlideoutOptionRow from '../FilterSlideoutOptionRow.jsx';
import { FILTER_SLIDEOUT_OPTION_LIST } from '../filterSlideoutTokens.js';
import {
  clearSection,
  getSectionActiveCount,
  joinClasses,
} from '../filterSlideout.utils.js';

function DirectionButton({ direction, current, label, icon: Icon, onClick }) {
  const isActive = (current ?? 'desc') === direction;
  return (
    <button
      type="button"
      className={joinClasses(
        'inline-flex h-8 items-center gap-2 rounded border px-3 text-xs font-medium',
        isActive
          ? 'border-[#2173FF] bg-[#E9F1FF] text-[#001740]'
          : 'border-edge bg-surface text-content-secondary',
      )}
      onClick={onClick}
    >
      <Icon size={14} aria-hidden />
      {label}
    </button>
  );
}

const SortSection = ({ section }) => {
  const activeCount = getSectionActiveCount(section);
  return (
  <FilterSlideoutSection
    title={section.title}
    defaultExpanded={section.defaultExpanded ?? true}
    disabled={section.disabled}
    activeCount={activeCount}
    onClear={() => clearSection(section)}
  >
    <div className="flex flex-col gap-3">
      <div className={FILTER_SLIDEOUT_OPTION_LIST}>
        {(section.options ?? []).map((option) => (
          <FilterSlideoutOptionRow
            key={option.value}
            control="radio"
            checked={section.value === option.value}
            disabled={section.disabled || option.disabled}
            label={option.label}
            onToggle={() => section.onChange?.(option.value)}
          />
        ))}
      </div>

      <div className="flex items-center gap-2 pl-1">
        <DirectionButton
          direction="asc"
          current={section.direction}
          label="Asc"
          icon={ArrowUp}
          onClick={() => section.onDirectionChange?.('asc')}
        />
        <DirectionButton
          direction="desc"
          current={section.direction}
          label="Desc"
          icon={ArrowDown}
          onClick={() => section.onDirectionChange?.('desc')}
        />
      </div>
    </div>
  </FilterSlideoutSection>
  );
};

export default memo(SortSection);
